import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { CLAIM_COUNTS_BY_DISEASE_REPORT_QUERY, CLAIM_COUNTS_BY_STATE_REPORT_QUERY } from '../../../graphql.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import '../Custom.css'
import ReportGrid from '../ReportGrid.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const CLAIM_COUNTS_BY_DISEASE_REPORT = gql(CLAIM_COUNTS_BY_DISEASE_REPORT_QUERY)
const CLAIM_COUNTS_BY_STATE_REPORT = gql(CLAIM_COUNTS_BY_STATE_REPORT_QUERY)

export default function ClaimCountsByReport({ location, reportType }) {
  console.log('ClaimCountsByReport rendered', reportType)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    const GQL = reportType === 'S' ? CLAIM_COUNTS_BY_STATE_REPORT : CLAIM_COUNTS_BY_DISEASE_REPORT
    const gqlData = reportType === 'S' ? 'claimCountsByState' : 'claimCountsByDisease'
    getData(location, GQL, gqlData, setResults, setGraphQLErrors)
  }, [location, reportType])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const title = reportType === 'S' ? 'Summary of Claims by Current Diagnosis and State' : 'Summary of Claims by Current Dianosis'
    const formatter = new Intl.NumberFormat()
    const totalColumns = [
      { columnNumber: 2, formatter: formatter.format },
      { columnNumber: 3, formatter: formatter.format },
      { columnNumber: 4, formatter: formatter.format },
      { columnNumber: 5, formatter: formatter.format },
      { columnNumber: 6, formatter: formatter.format },
      { columnNumber: 7, formatter: formatter.format },
      { columnNumber: 8, formatter: formatter.format },
      { columnNumber: 9, formatter: formatter.format },
      { columnNumber: 10, formatter: formatter.format }
    ]
    const csvFunction = reportType === 'S' ? 'claimCountsByState' : 'claimCountsByDisease'
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl(`Asbestos/${csvFunction}/claim_counts`, location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{ backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto' }} >
          <ReportHeading title={title} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} alignment={['left', 'right', 'right', 'right', 'right', 'right', 'right', 'right', 'right', 'right']} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} />
          </tbody>
        </Table>
      </div>
    )
  }
}